import { render, staticRenderFns } from "./production-list-view.vue?vue&type=template&id=77aada40"
import script from "./production-list-view.vue?vue&type=script&lang=js"
export * from "./production-list-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports